var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGTranslate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_716_12800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 4H11.5L10.5 1H3.5C2.4 1 1.5 1.9 1.5 3V18C1.5 19.1 2.4 20 3.5 20H11.5L12.5 23H21.5C22.6 23 23.5 22.1 23.5 21V6C23.5 4.9 22.6 4 21.5 4ZM7.5 16C4.74 16 2.5 13.76 2.5 11C2.5 8.24 4.74 6 7.5 6C8.85 6 9.98 6.5 10.85 7.3L9.53 8.57C9.15 8.21 8.49 7.79 7.5 7.79C5.76 7.79 4.35 9.23 4.35 11C4.35 12.77 5.76 14.21 7.5 14.21C9.51 14.21 10.34 12.77 10.42 11.8H7.5V10.09H12.18C12.25 10.4 12.3 10.7 12.3 11.11C12.3 13.97 10.39 16 7.5 16ZM13.67 10.58H17.37C16.94 11.83 16.26 13.01 15.32 14.05C15.01 13.7 14.72 13.33 14.46 12.95L13.67 10.58ZM22 20.5C22 21.05 21.55 21.5 21 21.5H14.5L16.5 19L15.46 15.9L18.56 19L19.48 18.08L16.18 14.83L16.2 14.81C17.33 13.56 18.13 12.12 18.6 10.59H20.5V9.29H15.97V8H14.68V9.29H13.24L11.96 5.5H21C21.55 5.5 22 5.95 22 6.5V20.5Z",
    fill: "#6477E7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_716_12800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGTranslate);
export default __webpack_public_path__ + "static/media/g_translate.0b03bda57a74ac9283226214f65afbe8.svg";
export { ForwardRef as ReactComponent };